import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store/configureStore";
import {
  IRequestOnMonetizationStatus,
  MonetizationRequestStatusApi,
} from "../Services/monetizationRequestStatus";

interface IMonetizationRequest {
  isFetching: boolean;
  error: Error | null;
}

const initialState: IMonetizationRequest = {
  isFetching: false,
  error: null,
};

const monetizationRequestSlice = createSlice({
  name: "monetizationRequest",
  initialState,
  reducers: {
    setFetching: (state, action) => {
      const { payload } = action;
      state.isFetching = payload;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.error = payload;
    },
  },
});

export const { setFetching } = monetizationRequestSlice.actions;

export const requestOnMonetizationStatusT = (
  payload: IRequestOnMonetizationStatus
): AppThunk => async (dispatch) => {
  dispatch(setFetching(true));
  try {
    await MonetizationRequestStatusApi.requestOnMonetizationStatus(payload);
  } catch (error) {
  } finally {
    dispatch(setFetching(false));
  }
};

export default monetizationRequestSlice.reducer;
